import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import HideDataIgnoreAttributeIcon from './icon/hidedataignoreattribute-icon.svg';
import HideDataIgnoreAttributeCommand from './hidedataignoreattributecommand';

export default class HideDataIgnoreAttributeCommandUI extends Plugin {

  init() {
    const editor = this.editor;
    const t = editor.t;
    let isPluginActive = false;
    this.editor.commands.add('hidedataignoreattribute', new HideDataIgnoreAttributeCommand(this.editor));
    editor.ui.componentFactory.add('hidedataignoreattribute', locale => {
      const view = new ButtonView(locale);
      view.set({
        label: t('Hide empty un-editable sections'),
        isToggleable: true,
        tooltip: true,
        icon: HideDataIgnoreAttributeIcon,
        class: 'ck-on'
      });

      const command = editor.commands.get('hidedataignoreattribute');
      view.bind('isOn').to(command, 'value');

      this.listenTo(view, 'execute', () => {
        toogleHideRowButton();
      });

      const undoCommand = this.editor.commands.get('undo');
      undoCommand.on('execute', () => {
        executePluginOnUndoRedo();
      })
      const redoCommand = this.editor.commands.get('redo');
      redoCommand.on('execute', () => {
        executePluginOnUndoRedo();
      })

      function toogleHideRowButton() {
        isPluginActive = !isPluginActive;
        view.isOn = !isPluginActive;
        view.class = isPluginActive ? "ck-off" : "ck-on";
        editor.execute('hidedataignoreattribute', { value: isPluginActive });
        editor.editing.view.focus();
      }

      function executePluginOnUndoRedo() {
        const dataHideRowsEle = editor.editing.view.domRoots.get('main').querySelectorAll(`[data-hiderows=" "]`);
        const dataShowRowsEle = editor.editing.view.domRoots.get('main').querySelectorAll(`[data-showrows=" "]`);
        if(dataHideRowsEle.length > 0) {
          isPluginActive = false;
        } else if(dataShowRowsEle.length > 0) {
          isPluginActive = true;
        }
        isPluginActive = !isPluginActive;
        view.isOn = !isPluginActive;
        view.class = isPluginActive ? "ck-off" : "ck-on";
        editor.execute('hidedataignoreattribute', { value: isPluginActive });
      }

      return view;
    });
  }
}
